import { isWebAuthnAssertion, verifyWebAuthnAssertion, } from './webauthn.js';
/**
 * Verify that a passkey assertion over `challenge` was produced by one of the pinned,
 * non-revoked credentials. Every passkey-gated operation (endorsement, step-up, revocation,
 * enrollment) goes through here.
 */
export async function verifyPasskeyApproval(assertion, challenge, options) {
    if (!isWebAuthnAssertion(assertion))
        return { ok: false, reason: 'malformed' };
    const credential = options.credentials.find((c) => c.credentialId === assertion.credentialId);
    if (!credential)
        return { ok: false, reason: 'untrusted-credential' };
    if (options.revokedCredentials?.has(credential.credentialId)) {
        return { ok: false, reason: 'revoked-credential' };
    }
    const previous = options.previousSignCount?.(credential.credentialId);
    const result = await verifyWebAuthnAssertion(assertion, {
        credential,
        expectedChallenge: challenge,
        rp: options.rp,
        requireUserVerification: true,
        ...(previous === undefined ? {} : { previousSignCount: previous }),
    });
    if (!result.ok) {
        return result.detail === undefined
            ? { ok: false, reason: result.reason }
            : { ok: false, reason: result.reason, detail: result.detail };
    }
    return { ok: true, credential, signCount: result.signCount };
}
//# sourceMappingURL=approval.js.map